import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { postRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';

const getAuthHeaders = () => {
  const token = localStorage.getItem('userToken') || sessionStorage.getItem('userToken');
  return { headers: { Authorization: `Bearer ${token}` } };
};

const AddDepartment = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    heading: '',
    subheading: '',
    image: null,
    highlights: '',
    vision: '',
    mission: '',
    status: 'active',
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (e.target.type === 'file') {
      setFormData((prev) => ({
        ...prev,
        [name]: files && files.length > 0 ? files[0] : null,
      }));
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.heading.trim()) {
      toast.error('Heading is required');
      return;
    }

    setLoading(true);

    const payload = new FormData();
    payload.append('heading', formData.heading.trim());
    payload.append('subheading', formData.subheading.trim());
    payload.append('highlights', formData.highlights.trim());
    payload.append('vision', formData.vision.trim());
    payload.append('mission', formData.mission.trim());
    payload.append('status', formData.status);

    if (formData.image) {
      payload.append('image', formData.image);
    }

    try {
      const response = await postRequest('departments', payload, getAuthHeaders());

      if (response?.data?.success) {
        toast.success('Department created successfully');
        navigate('/departments');
      } else {
        toast.error(response?.data?.message || 'Failed to create department');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message || 'Failed to create department');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="font-weight-bold">Add Department</h4>
      </div>

      <form onSubmit={handleSubmit} className="form-style">
        <div className="row mx-4 mt-5">
          <div className="col-md-6 mt-2">
            <label htmlFor="heading">Department Name *</label>
            <input
              id="heading"
              name="heading"
              className="form-control"
              value={formData.heading}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-6 mt-2">
            <label htmlFor="subheading">Description</label>
            <input
              id="subheading"
              name="subheading"
              className="form-control"
              value={formData.subheading}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 mt-2">
            <label htmlFor="image">Image (optional)</label>
            <input
              id="image"
              name="image"
              type="file"
              className="form-control-file"
              accept="image/*"
              onChange={handleChange}
            />
            {formData.image && (
              <small className="text-muted d-block mt-1">Selected: {formData.image.name}</small>
            )}
          </div>

          <div className="col-md-6 mt-2">
            <label htmlFor="status">Status</label>
            <select
              id="status"
              name="status"
              className="form-control"
              value={formData.status}
              onChange={handleChange}
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>

          <div className="col-12 mt-2">
            <label htmlFor="highlights">Highlights (optional)</label>
            <textarea
              id="highlights"
              name="highlights"
              rows="3"
              className="form-control"
              value={formData.highlights}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 mt-2">
            <label htmlFor="vision">Vision (optional)</label>
            <textarea
              id="vision"
              name="vision"
              rows="4"
              className="form-control"
              value={formData.vision}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 mt-2">
            <label htmlFor="mission">Mission (optional)</label>
            <textarea
              id="mission"
              name="mission"
              rows="4"
              className="form-control"
              value={formData.mission}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="mt-5 text-right mx-4">
          <button type="submit" className="btn btn-lg addbtn" disabled={loading}>
            {loading ? 'Creating...' : 'Create Department'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddDepartment;